import React from 'react';
import Loadable from 'react-loadable';
import { RouteComponentProps } from 'react-router';

import BlankLoadingPage from '../../../../shared/components/BlankLoadingPage';
import { getQueryFromLocation } from '../../../../shared/utils/urls';
import { LoadableWidgetOfficeSchedulingPage } from '../../../index';

const LoadableNewOfficeSchedulingPage = Loadable({
  loader: () =>
    import(/* webpackChunkName: "newOfficeSchedulingPage" */ './NewOfficeSchedulingPage'),
  loading: () => <BlankLoadingPage />,
});

type Params = { id: string };

export default function NewOfficeSchedulingPage(props: RouteComponentProps<Params>) {
  const { exp_widget_v2 } = getQueryFromLocation(props.location);

  if (exp_widget_v2 == null || exp_widget_v2 === '') {
    return <LoadableWidgetOfficeSchedulingPage {...props} />;
  }
  return <LoadableNewOfficeSchedulingPage {...props} />;
}
